import { render } from "./PasswordStrength.vue?vue&type=template&id=84f8c742&scoped=true&ts=true"
import script from "./PasswordStrength.vue?vue&type=script&lang=ts"
export * from "./PasswordStrength.vue?vue&type=script&lang=ts"

import "./PasswordStrength.vue?vue&type=style&index=0&id=84f8c742&scoped=true&lang=css"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f8c742"]])

export default __exports__